import {
    OVERVIEWDESIGNER_DELETE_OVERVIEW
} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';

import {
    DeleteOverviewParameters,
    DeleteOverviewResult
} from '~/shared/src/utilities/modules/overview';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';
import xhr from '~/frontend/src/utilities/xhr';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {number} overviewId
 * @param {( responseData : DeleteOverviewResult ) => void} [successCallback]
 *
 * @return {Promise<DeleteOverviewResult | false>}
 */
const deleteOverview = ( panelKey : string, overviewId : number, successCallback? : ( responseData : DeleteOverviewResult ) => void ) : Thunk<Promise<DeleteOverviewResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<DeleteOverviewResult | false> => {
    dispatch( {
        type: OVERVIEWDESIGNER_DELETE_OVERVIEW,
        panelKey,
        overviewId
    } );

    let retVal : DeleteOverviewResult | false = false;

    dispatch( clearElusiveData( panelKey ) );

    const params : DeleteOverviewParameters = {
              viewId: overviewId
          },
          response                          = await xhr.post(
              `${BASE_URL}/api/overview/deleteOverview`,
              params,
              undefined,
              panelKey,
              'deleteOverview',
              dispatch
          );

    if ( response?.data.success && !response.data.errorTitle ) {
        if ( successCallback ) {
            successCallback( response.data as DeleteOverviewResult );
        }

        retVal = response.data as DeleteOverviewResult;
    }

    return retVal;
};
export type DeleteOverview = typeof deleteOverview;

export default deleteOverview;
